import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Navigate, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Menu from "./Menu";
import Spinner from "./Spinner";

const TIPO_FRASE_EVOLUCION_PSICOLOGICA = "Evolución psicológica";

export default function EvaluacionPsicologica() {
  const navigate = useNavigate();
  const toast = useRef(null);
  const [dialogPacientes, setDialogPacientes] = useState(false);
  const [dialogEvoluciones, setDialogEvoluciones] = useState(false);
  const [dialogEvolucion, setDialogEvolucion] = useState(false);
  const [dialogFrasesEvolucion, setDialogFrasesEvolucion] = useState(false);
  const [dialogAdministrarFrases, setDialogAdministrarFrases] = useState(false);
  const [dialogUltimasEvaluacionesPsicologicas, setDialogUltimasEvaluacionesPsicologicas] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [selectedRowPacienteDialog, setSelectedRowPacienteDialog] = useState(null);
  const [selectedRowEvolucionPsicologica, setSelectedRowEvolucionPsicologica] = useState(null);
  const [evolucionPsicologica, setEvolucionPsicologica] = useState("");
  const [frasePsicologicaId, setFrasePsicologicaId] = useState(null);
  const [textoFrasePsicologica, setTextoFrasePsicologica] = useState("");
  const [modoEvolucion, setModoEvolucion] = useState("agregar");

  const { state, usuarioAutenticado } = useContext(AuthContext);
  const {
    statusAcceso,
    pacientes,
    selectedRowPaciente,
    geriatricoElegido,
    obrasSociales,
    obrasSocialesMedicas,
    evolucionesPsicologicas,
    ultimasEvaluacionesPsicologicas,
    frasesPsicologicas,
    obtenerAcceso,
    obtenerPacientes,
    obtenerObrasSocialesPacientes,
    obtenerObrasSocialesMedicasPacientes,
    setSelectedRowPaciente,
    obtenerEvolucionesPsicologicas,
    obtenerUltimasEvaluacionesPsicologicas,
    agregarEvolucionPsicologica,
    obtenerFrasesPsicologicas,
    agregarFrasePsicologica,
    actualizarFrasePsicologica,
    setGeriatricoElegido,
  } = useContext(ServiciosContext);

  useEffect(() => {
    usuarioAutenticado();
    setGeriatricoElegido({
      id: Number(localStorage.getItem("geriatricoElegidoId")),
      nombre: localStorage.getItem("geriatricoElegidoNombre"),
    });
    obtenerPacientes({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
    obtenerFrasesPsicologicas({ tipo: TIPO_FRASE_EVOLUCION_PSICOLOGICA });
    obtenerObrasSocialesPacientes({ todos: false });
    obtenerObrasSocialesMedicasPacientes({ todos: false });
    // Las funciones del contexto no tienen referencias estables.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "Evaluaciones",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.usuario]);

  const todasEvaluacionesPsicologicas = () => {
    obtenerUltimasEvaluacionesPsicologicas({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
    setDialogUltimasEvaluacionesPsicologicas(true);
  };

  const abrirPacientes = () => {
    setSelectedRowPacienteDialog(null);
    setDialogPacientes(true);
  };

  const cargarDatosPsicologicos = (pacienteId) => {
    obtenerEvolucionesPsicologicas({ pacienteId });
  };

  const aceptarPaciente = () => {
    if (!selectedRowPacienteDialog) {
      toast.current.show({
        severity: "info",
        summary: "Evaluación psicológica",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
      return;
    }

    setSelectedRowPaciente(selectedRowPacienteDialog);
    setSelectedRowEvolucionPsicologica(null);
    setEvolucionPsicologica("");
    cargarDatosPsicologicos(selectedRowPacienteDialog.id);
    setDialogPacientes(false);
    setDialogEvoluciones(true);
  };

  const abrirAgregarEvolucion = () => {
    setModoEvolucion("agregar");
    setSelectedRowEvolucionPsicologica(null);
    setEvolucionPsicologica("");
    setDialogEvolucion(true);
  };

  const abrirVerEvolucion = () => {
    if (!selectedRowEvolucionPsicologica) {
      toast.current.show({
        severity: "info",
        summary: "Evolución psicológica",
        detail: "Debe seleccionar una evolución.",
        life: 3000,
      });
      return;
    }

    setModoEvolucion("ver");
    setEvolucionPsicologica(selectedRowEvolucionPsicologica.evolucion || "");
    setDialogEvolucion(true);
  };

  const guardarEvolucion = async () => {
    if (!selectedRowPaciente) {
      toast.current.show({
        severity: "info",
        summary: "Evolución psicológica",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
      return;
    }

    if (!evolucionPsicologica.trim()) {
      toast.current.show({
        severity: "info",
        summary: "Evolución psicológica",
        detail: "Debe ingresar una evolución.",
        life: 3000,
      });
      return;
    }

    const guardado = await agregarEvolucionPsicologica({
      pacienteId: selectedRowPaciente.id,
      evolucion: evolucionPsicologica,
      usuario: state.usuario,
    });

    if (guardado) {
      setEvolucionPsicologica("");
      setDialogEvolucion(false);
      obtenerEvolucionesPsicologicas({ pacienteId: selectedRowPaciente.id });
    }
  };

  const limpiarFrasePsicologica = () => {
    setFrasePsicologicaId(null);
    setTextoFrasePsicologica("");
  };

  const abrirAdministrarFrases = () => {
    limpiarFrasePsicologica();
    obtenerFrasesPsicologicas({ tipo: TIPO_FRASE_EVOLUCION_PSICOLOGICA });
    setDialogAdministrarFrases(true);
  };

  const editarFrasePsicologica = (frasePsicologica) => {
    setFrasePsicologicaId(frasePsicologica.id);
    setTextoFrasePsicologica(frasePsicologica.frase || "");
  };

  const guardarFrasePsicologica = async () => {
    if (!textoFrasePsicologica.trim()) {
      toast.current.show({
        severity: "info",
        summary: "Frases psicológicas",
        detail: "Debe ingresar una frase.",
        life: 3000,
      });
      return;
    }

    const datos = {
      tipo: TIPO_FRASE_EVOLUCION_PSICOLOGICA,
      frase: textoFrasePsicologica,
    };

    const guardado = frasePsicologicaId
      ? await actualizarFrasePsicologica({ ...datos, id: frasePsicologicaId })
      : await agregarFrasePsicologica(datos);

    if (guardado) {
      limpiarFrasePsicologica();
      obtenerFrasesPsicologicas({ tipo: TIPO_FRASE_EVOLUCION_PSICOLOGICA });
    }
  };
  const abrirFrasesEvolucion = () => {
    obtenerFrasesPsicologicas({ tipo: TIPO_FRASE_EVOLUCION_PSICOLOGICA });
    setDialogFrasesEvolucion(true);
  };

  const insertarFrase = (frase) => {
    if (!frase) return;
    setEvolucionPsicologica((actual) => (actual ? `${actual}\n${frase}` : frase));
    setDialogFrasesEvolucion(false);
  };

  const formatDate = (fecha) => {
    if (!fecha) return "";
    const date = fecha.slice(0, 10).split("-");
    if (date.length !== 3) return fecha;
    return [date[2], date[1], date[0]].join("/");
  };

  const headerPacientes = (
    <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
      <Typography variant="h6">Seleccionar residente</Typography>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
        />
      </span>
    </div>
  );

  const headerEvoluciones = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Button
          icon="pi pi-plus"
          tooltip="Agregar"
          className="p-button-rounded p-button-help"
          onClick={abrirAgregarEvolucion}
        />
        <Button
          icon="pi pi-pencil"
          tooltip="Ver"
          className="p-button-rounded p-button-success"
          style={{ marginLeft: "1em" }}
          onClick={abrirVerEvolucion}
        />
      </div>
    </Fragment>
  );
  function getEdad(dateString) {
    let hoy = new Date();
    let fechaNacimiento = new Date(dateString);
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
    if (
      diferenciaMeses < 0 ||
      (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
    ) {
      edad--;
    }
    return edad;
  }
  const imprimirUltimasEvaluacionesPsicologicas = () => {
    const doc = new jsPDF();
    const sumarCampos = (objeto, campos) =>
      objeto
        ? campos.reduce(
            (total, campo) => total + Number(objeto[campo] || 0),
            0,
          )
        : "";
    const obtenerNombreObraSocial = (opciones, id) => {
      const opcion = opciones && opciones.find((item) => item.id === id);
      return opcion ? opcion.label : "";
    };
    const escribirLista = (items, row) => {
      doc.setFontSize(9);
      (items || []).forEach((item) => {
        const lineas = doc.splitTextToSize(`-${item}`, 180);
        doc.text(lineas, 10, row);
        row += lineas.length * 5;
      });
      doc.setFontSize(10);
      return row;
    };
    const escribirTexto = (texto, row) => {
      const lineas = doc.splitTextToSize(texto || "", 180);
      if (lineas.length > 0) {
        doc.text(lineas, 10, row);
      }
      return row + lineas.length * 5;
    };

    (ultimasEvaluacionesPsicologicas || []).forEach((item, index) => {
      if (index > 0) {
        doc.addPage();
      }

      doc.setFontSize(12);
      doc.setFont("Times", "bolditalic");
      doc.text((geriatricoElegido && geriatricoElegido.nombre) || "", 15, 8);
      doc.rect(10, 12, 190, 30);
      doc.setFontSize(14);
      doc.setFont("Times", "bolditalic");
      doc.text("EVALUACION PSICOLOGICA PERIODICA", 45, 20);
      doc.setFont("Times", "normal");
      doc.setFontSize(10);

      let row = 25;
      doc.text(`Paciente: ${item.nombre || ""}`, 12, row);
      doc.text(`D.N.I.: ${item.numeroDocumento || ""}`, 130, row);
      row += 5;
      doc.text(
        `Fecha Nacimiento: ${item.fechaNacimiento ? formatDate(item.fechaNacimiento) : ""}`,
        12,
        row,
      );
      doc.text(
        `Edad: ${item.fechaNacimiento ? getEdad(item.fechaNacimiento) : ""}`,
        130,
        row,
      );
      row += 5;
      doc.text(
        `Fecha de Ingreso a la Institucion: ${item.fechaIngreso ? formatDate(item.fechaIngreso) : ""}`,
        12,
        row,
      );
      doc.text(
        `Obra Social Contrato: ${obtenerNombreObraSocial(
          obrasSociales,
          item.obraSocialContratoId,
        )}`,
        130,
        row,
      );
      row += 5;
      doc.text(
        `Obra Social Medica: ${obtenerNombreObraSocial(
          obrasSocialesMedicas,
          item.obraSocialId,
        )}`,
        12,
        row,
      );
      doc.text(`Nro Obra Social: ${item.numeroObraSocial || ""}`, 130, row);
      row += 10;

      doc.text(`Fecha: ${item.fecha ? formatDate(item.fecha) : ""}`, 12, row);
      row += 10;

      doc.text("DIAGNOSTICOS DE INGRESO: ", 10, row);
      row += 5;
      row = escribirLista(item.diagnosticos, row);
      row += 5;

      doc.text("EVALUACION DE INGRESO: ", 10, row);
      row += 10;
      doc.text(
        `BARTHEL: ${sumarCampos(item.barthel, [
          "comer",
          "lavarse",
          "vestirse",
          "arreglarse",
          "deposiciones",
          "miccion",
          "retrete",
          "trasladarse",
          "deambular",
          "escalones",
        ])}`,
        10,
        row,
      );
      doc.text(
        `LAWTON Y BRODY: ${sumarCampos(item.lawtonBrody, [
          "telefonoResultado",
          "comprasResultado",
          "comidaResultado",
          "casaResultado",
          "ropaResultado",
          "transporteResultado",
          "medicacionResultado",
          "economicoResultado",
        ])}`,
        60,
        row,
      );
      doc.text(
        `TINETTI: ${sumarCampos(item.tinetti, [
          "equilibrioSentado",
          "levantarse",
          "intentoLevantarse",
          "equilibrioSegundos",
          "equilibrioProlongado",
          "rombergSensibilizado",
          "romberg",
          "girar",
          "girar2",
          "sentarse",
        ])}`,
        110,
        row,
      );
      doc.text(
        `NORTON: ${sumarCampos(item.norton, [
          "estadoFisico",
          "estadoMental",
          "actividad",
          "movilidad",
          "incontinencia",
        ])}`,
        150,
        row,
      );
      row += 5;

      const totalFragilidad = item.fragilidad
        ? Array.from({ length: 27 }, (_, indice) => indice + 1).reduce(
            (total, numero) =>
              total +
              Number(
                item.fragilidad[`pregunta${numero}`]
                  ? item.fragilidad[`pregunta${numero}Value`] || 0
                  : 0,
              ),
            0,
          )
        : "";
      const observacionesFragilidad =
        item.fragilidad && item.fragilidad.observaciones
          ? ` - ${item.fragilidad.observaciones}`
          : "";
      row = escribirTexto(
        `MARCADORES DE FRAGILIDAD: ${totalFragilidad}${observacionesFragilidad}`,
        row,
      );
      row += 5;

      doc.text(
        "_____________________________________________________________________________________________",
        10,
        row,
      );
      row += 10;

      doc.text("MEDICACION: ", 10, row);
      row += 5;
      row = escribirLista(item.medicaciones, row);
      row += 5;

      doc.text("EVOLUCION PSICOLOGICA: ", 10, row);
      row += 5;
      row = escribirTexto(item.evolucionPsicologicaId ? item.evolucion : "Sin evaluaciones psicológicas.", row);
      doc.text(
        "_____________________________________________________________________________________________",
        10,
        row,
      );

      doc.text("FIRMA Y SELLO", 90, 290);
    });

    window.open(doc.output("bloburl"));
  };
  const footerPacientes = (
    <div>
      <ButtonMui
        onClick={aceptarPaciente}
        color="primary"
        type="button"
        fullWidth
        variant="contained"
        startIcon={<CheckIcon />}
      >
        Aceptar
      </ButtonMui>
      <ButtonMui
        onClick={() => setDialogPacientes(false)}
        color="secondary"
        type="button"
        fullWidth
        variant="contained"
        startIcon={<CloseIcon />}
        autoFocus
      >
        Cancelar
      </ButtonMui>
    </div>
  );

  const footerEvolucion = (
    <div>
      {modoEvolucion === "agregar" ? (
        <ButtonMui
          onClick={guardarEvolucion}
          color="primary"
          type="button"
          variant="contained"
        >
          Aceptar
        </ButtonMui>
      ) : null}
      <ButtonMui
        onClick={() => setDialogEvolucion(false)}
        color="secondary"
        type="button"
        variant="contained"
        style={{ marginLeft: "0.75rem" }}
      >
        Cancelar
      </ButtonMui>
    </div>
  );
  const accesoDenegado = () => <Navigate to="/" replace />;

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Grid container spacing={2} style={{ padding: "1rem", marginTop: "3vw" }}>
          <Grid item xs={12}>
            <Button
              icon="pi pi-search"
              tooltip="Residentes"
              className="p-button-rounded p-button-help"
              onClick={abrirPacientes}
            />
            <Button
              icon="pi pi-align-justify"
              tooltip="Frases psicológicas"
              className="p-button-rounded p-button-success"
              style={{ marginLeft: "1rem" }}
              onClick={abrirAdministrarFrases}
            />
            <Button
              icon="pi pi-chart-bar"
              tooltip="Evaluaciones Pacientes"
              className="p-button-rounded p-button-secondary"
              style={{ marginLeft: "1rem" }}
              onClick={todasEvaluacionesPsicologicas}
            />
            <Button
              icon="pi pi-times"
              tooltip="Cerrar"
              className="p-button-rounded p-button-primary"
              style={{ marginLeft: "1rem" }}
              onClick={() => navigate("/")}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5">Evaluación Psicológica Periódica</Typography>
            <Typography variant="body1">
              Seleccione un residente para consultar su evaluación psicológica.
            </Typography>
          </Grid>
        </Grid>
      ) : null}

      <Dialog
        visible={dialogPacientes}
        header={headerPacientes}
        footer={footerPacientes}
        onHide={() => setDialogPacientes(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "75vw" }}
        position="top"
      >
        <DataTable
          value={pacientes || []}
          selection={selectedRowPacienteDialog}
          onSelectionChange={(e) => setSelectedRowPacienteDialog(e.value)}
          selectionMode="single"
          dataKey="id"
          globalFilter={globalFilter}
          emptyMessage="No hay residentes."
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          responsiveLayout="scroll"
          className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
        >
          <Column field="id" header="ID" sortable />
          <Column field="nombre" header="Apellido y nombre" sortable />
          <Column field="numeroDocumento" header="Documento" sortable />
          <Column field="domicilio" header="Domicilio" sortable />
          <Column field="activo" header="Activo" body={(row) => (row.activo ? "Sí" : "No")} sortable />
        </DataTable>
      </Dialog>

      <Dialog
        header={
          selectedRowPaciente ? <Tag value={`Evoluciones psicológicas de ${selectedRowPaciente.nombre}`} /> : null
        }
        visible={dialogEvoluciones}
        closable={true}
        onHide={() => setDialogEvoluciones(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "75vw", paddingBottom: "0" }}
        position="top"
      >
        <DataTable
          value={evolucionesPsicologicas || []}
          selection={selectedRowEvolucionPsicologica}
          onSelectionChange={(e) => setSelectedRowEvolucionPsicologica(e.value)}
          selectionMode="single"
          dataKey="id"
          header={headerEvoluciones}
          className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
          emptyMessage="No hay evoluciones psicológicas."
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          responsiveLayout="scroll"
        >
          <Column field="fecha" header="Fecha" body={(row) => formatDate(row.fecha)} sortable />
          <Column field="evolucion" header="Evolución" sortable />
          <Column field="usuario" header="Usuario" sortable />
        </DataTable>
      </Dialog>

      <Dialog
        header={modoEvolucion === "agregar" ? "Agregar evolución psicológica" : "Ver evolución psicológica"}
        visible={dialogEvolucion}
        maximized={true}
        closable={true}
        footer={footerEvolucion}
        onHide={() => setDialogEvolucion(false)}
      >
        <Grid container spacing={2} style={{ paddingTop: "0.5rem" }}>
          <Grid item xs={12}>
            <Button
              icon="pi pi-align-justify"
              tooltip="Frases evolución"
              className="p-button-rounded p-button-warning"
              onClick={abrirFrasesEvolucion}
              disabled={modoEvolucion !== "agregar"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={5}
              label={modoEvolucion === "agregar" ? "Nueva evolución psicológica" : "Evolución psicológica"}
              value={evolucionPsicologica}
              onChange={(e) => setEvolucionPsicologica(e.target.value)}
              disabled={modoEvolucion !== "agregar"}
            />
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        header={<Tag value="Frases psicológicas" />}
        visible={dialogAdministrarFrases}
        onHide={() => setDialogAdministrarFrases(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "55rem", maxWidth: "95vw" }}
        position="top"
        footer={
          <div>
            <Button
              label={frasePsicologicaId ? "Modificar" : "Agregar"}
              icon="pi pi-check"
              className="p-button-success"
              onClick={guardarFrasePsicologica}
            />
            <Button
              label="Nueva"
              icon="pi pi-plus"
              className="p-button-help"
              style={{ marginLeft: "0.75rem" }}
              onClick={limpiarFrasePsicologica}
            />
            <Button
              label="Cerrar"
              icon="pi pi-times"
              className="p-button-secondary"
              style={{ marginLeft: "0.75rem" }}
              onClick={() => setDialogAdministrarFrases(false)}
            />
          </div>
        }
      >
        <Grid container spacing={2} style={{ paddingTop: "0.5rem" }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              label={frasePsicologicaId ? "Modificar frase" : "Nueva frase"}
              value={textoFrasePsicologica}
              onChange={(e) => setTextoFrasePsicologica(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ marginBottom: "0.5rem" }}>
              Textos cargados para evolución psicológica
            </Typography>
            {frasesPsicologicas && frasesPsicologicas.length > 0 ? (
              frasesPsicologicas.map((item) => (
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "0.75rem",
                    padding: "0.75rem 0",
                    borderBottom: "1px solid #d9d9d9",
                  }}
                >
                  <Typography variant="body1" style={{ flex: 1, whiteSpace: "pre-wrap" }}>
                    {item.frase}
                  </Typography>
                  <Button
                    icon="pi pi-pencil"
                    tooltip="Modificar frase"
                    className="p-button-rounded p-button-success"
                    onClick={() => editarFrasePsicologica(item)}
                  />
                </div>
              ))
            ) : (
              <Typography variant="body2">No hay frases cargadas.</Typography>
            )}
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        header={
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Tag value="Ultima evaluacion psicologica de pacientes activos" />
            <Button
              icon="pi pi-print"
              tooltip="Imprimir listado"
              className="p-button-rounded p-button-help"
              onClick={imprimirUltimasEvaluacionesPsicologicas}
              disabled={!ultimasEvaluacionesPsicologicas || ultimasEvaluacionesPsicologicas.length === 0}
            />
          </div>
        }
        visible={dialogUltimasEvaluacionesPsicologicas}
        closable={true}
        onHide={() => setDialogUltimasEvaluacionesPsicologicas(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "90vw", paddingBottom: "0" }}
        position="top"
      >
        <div style={{ width: "100%" }}>
          {ultimasEvaluacionesPsicologicas && ultimasEvaluacionesPsicologicas.length > 0 ? (
            ultimasEvaluacionesPsicologicas.map((item) => (
              <div
                key={item.pacienteId}
                style={{
                  padding: "1rem 0",
                  borderBottom: "1px solid #d9d9d9",
                }}
              >
                <Typography variant="h6" style={{ marginBottom: "0.5rem" }}>
                  {item.nombre} - DNI {item.numeroDocumento}
                </Typography>
                {item.evolucionPsicologicaId ? (
                  <Fragment>
                    <Typography variant="body2" style={{ marginBottom: "0.5rem" }}>
                      Fecha: {formatDate(item.fecha)} | Usuario: {item.usuario || "-"}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Evolucion psicologica:</strong> {item.evolucion || "-"}
                    </Typography>
                  </Fragment>
                ) : (
                  <Typography variant="body2">Sin evaluaciones psicológicas.</Typography>
                )}
              </div>
            ))
          ) : (
            <Typography variant="body1">No hay pacientes activos.</Typography>
          )}
        </div>
      </Dialog>      <Dialog
        header="Frases evolución"
        visible={dialogFrasesEvolucion}
        onHide={() => setDialogFrasesEvolucion(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "45rem", maxWidth: "95vw" }}
        position="top"
      >
        {frasesPsicologicas && frasesPsicologicas.length > 0 ? (
          frasesPsicologicas.map((item) => (
            <div key={item.id} style={{ borderBottom: "1px solid #d9d9d9" }}>
              <ButtonMui
                fullWidth
                onClick={() => insertarFrase(item.frase)}
                style={{ justifyContent: "flex-start", textAlign: "left", padding: "0.75rem" }}
              >
                {item.frase}
              </ButtonMui>
            </div>
          ))
        ) : (
          <Typography variant="body2">No hay frases cargadas.</Typography>
        )}
      </Dialog>
    </Fragment>
  );
}
